var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"fill-height"}},[_c('v-layout',[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"4"}},[_c('h1',{staticClass:"red--text text-center"},[_vm._v(" Access Denied – You don’t have permission to access ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }